import type { PriceModel } from "../src/types";

// Single source of truth for token-cost math, reused by the client calculator, the
// model/compare pages, the request-volume calculator, and the Worker SSR snapshots.
// Kept free of DOM globals so it can be imported from the Cloudflare Worker build.
export function monthlyCost(
  model: PriceModel,
  inputMillions: number,
  outputMillions: number,
  cachePercent = 0,
) {
  const cacheRatio = Math.min(100, Math.max(0, cachePercent)) / 100;
  const regularInput = inputMillions * (1 - cacheRatio) * model.cost.input;
  // Missing cache-read pricing falls back to the standard input rate: cached tokens
  // are never assumed to be cheaper than uncached ones when a discount isn't published.
  const cachedInput =
    inputMillions * cacheRatio * (model.cost.cacheRead ?? model.cost.input);
  return regularInput + cachedInput + outputMillions * model.cost.output;
}
